import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";
import moment from 'moment';

export function getContracts(context) {
    const {
        contracts,
        suppliers,
        clients,
        staff,
        currencies,
        exchangerates,
        basecurrency,
    } = context;

    const data = [];
    const currenttime = moment().unix();

    const generalledgerdata = getGeneralLedgerData(context);

    let filteredledgerdata = generalledgerdata
        .filter(data => data.credit > 0);

    contracts.forEach((contract) => {
        let currencySymbol = currencies.find((currency) => currency.id === contract.currencyid)?.symbol || '';

        let accountName = '';
        if (contract.accounttype === 'suppliers') accountName = suppliers.find((item) => item.id === contract.accountid)?.name || '';
        if (contract.accounttype === 'staff') accountName = staff.find((item) => item.id === contract.accountid)?.name || '';
        if (contract.accounttype === 'clients') accountName = clients.find((item) => item.id === contract.accountid)?.name || '';

        let accountledger = filteredledgerdata
            .filter(data => data.accounttype == contract.accounttype)
            .filter(data => data.accountid == contract.accountid)

        let paid = -getledgerbalance(accountledger, exchangerates, basecurrency, contract.accounttype);

        let status = '';
        let duepaymentcumulative = 0;

        let duepayment = '';
        let duename = '';
        let duedate = '';

        let nextdate = '';
        let nextname = '';
        let nextpayment = '';

        const sortedrows = [...(contract.rows || [])]
            .sort((a, b) => Number(a.date) - Number(b.date));

        if (paid >= contract.amount) status = 'Paid in full';

        if (paid < contract.amount) {
            for (let i = 0; i < sortedrows.length; i++) {
                const row = sortedrows[i];

                if (currenttime > row.date) {
                    duepaymentcumulative += Number(row.payment);
                    duedate = row.date;
                    duepayment = Number(row.payment);
                    duename = row.name;
                }
            }
            for (let i = 0; i < sortedrows.length; i++) {
                const row = sortedrows[i];
                if (currenttime < row.date) {
                    nextdate = row.date;
                    nextname = row.name;
                    nextpayment = row.payment;
                    break;
                }
            }
        }

        let duebalance = duepaymentcumulative - paid;
        if (duebalance > 0) status = 'Due unpaid is ' + duename + ' ' + currencySymbol + duebalance.toLocaleString('en-US');
        if (duebalance == 0) {
            if (nextpayment) {
                const datestring = moment.unix(nextdate).fromNow()
                status = 'Next payment ' + nextname + ' ' + currencySymbol + nextpayment + ' ' + datestring;
            }
            else {
                status = ''
            }
        }

        const contractData = {
            ...contract,
            accountname: accountName,
            status: status,
            paid: paid,
            balance: contract.amount - paid
        };

        data.push(contractData);
    });

    data.sort((a, b) => {
        const nameComparison = (a.accountname || "").localeCompare(b.accountname || "", 'en', { numeric: true });
        if (nameComparison === 0) {
            return (a.remaining || 0) - (b.remaining || 0);
        }
        return nameComparison;
    });

    return data;
}